<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="10" :sm="10">
            <a-form-item :label="$t(I18N_KEY.ORDER + 'settlementTime')">
              <a-range-picker
                v-model="queryParam.lendingTime"
                format="YYYY-MM-DD"
                style="width: 100%;"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'ProductType'">
              <a-select
                v-model="queryParam.appSsid"
                mode="multiple"
              >
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Term'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.duration">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="7">
                  7 Days
                </a-select-option>
                <a-select-option value="10">
                  10 Days
                </a-select-option>
                <a-select-option value="14">
                  14 Days
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'Fee Rate'">
              <a-input-number :placeholder="$t('enter') + ' Fee Rate'" v-model="queryParam.serviceFee" style="width:100%"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="4">
            <a-form-item :label="'Order Type'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.orderType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="0">
                  Normal Order
                </a-select-option>
                <a-select-option value="1">
                  Extension Order
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'SettledType'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.settleStatus">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="3">
                  Overdue Settlement
                </a-select-option>
                <a-select-option value="-3">
                  Non-overdue Settlement
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'SettledType'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.settleType">
                <a-select-option value="">
                  All
                </a-select-option>
                <a-select-option value="4">
                  Extension Settlement
                </a-select-option>
                <a-select-option value="-4">
                  Non-extension Settlement
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <!--<a-button type="primary" @click="downLoadData('')" icon="download" style="margin-left: 8px">Export</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
      </a-table>


    </div>
    <v-modal
        v-model="visible"
        :title="$t('order.collectionDetail')">
        <div style="padding: 20px;">
            <collection-detail
              v-if="visible"
              :orderId="orderId"
              :custInfoId="custInfoId"
              :taskId="taskId"
              :auditDrawer="false"
              @close="visible = false;"/>
        </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {getApplist, reborrowCount} from '@/webpublicapi/order'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import exportFile from '@/webpublicapi/exportFile'
import moment from 'moment'
import vModal from '../modules/Modal';
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}

export default {
  name: 'reborrowCount',
  components: {
    Dict,
    DictSelect,
    vModal,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      dataSource: [],
      appList: [],
      // Query conditions
      queryParam: {
        lendingTime:[]
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title:  'Actual Repayment Date',
          align: 'left',
          dataIndex: 'timeStr'
        },
        {
          title: 'Actual Repayment Count',
          align: 'left',
          dataIndex: 'countSettleOrder'
        },
        {
          title: 'Repayment Same Day Reborrow',
          align: 'left',
          dataIndex: 'curReborrowCount'
        },
        {
          title: 'RepaymentPage 2DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount2'
        },
        {
          title: 'RepaymentPage 3DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount3'
        },
        {
          title: 'RepaymentPage 4DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount4'
        },
        {
          title: 'RepaymentPage 5DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount5'
        },
        {
          title: 'RepaymentPage 6DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount6'
        },
        {
          title: 'RepaymentPage 7DaysReborrow',
          align: 'left',
          dataIndex: 'reborrowCount7'
        },
        {
          title: 'Total Reborrow Count',
          align: 'left',
          dataIndex: 'reborrowCount8'
        },
        {
          title: 'First Day Reborrow Rate',
          align: 'left',
          dataIndex: 'rate1'
        },
        {
          title: '7DayReborrowRate',
          align: 'left',
          dataIndex: 'rate7'
        },
        {
          title: '10DayReborrowRate',
          align: 'left',
          dataIndex: 'rate10'
        },
        {
          title: '15DayReborrowRate',
          align: 'left',
          dataIndex: 'rate15'
        },
        {
          title: 'ReborrowRate',
          align: 'left',
          dataIndex: 'rate'
        }

      ]
    },
  },
  created () {
    this.getTime();
    this.getDict();
    this.loadData();
    getApplist().then(res => {
      this.appList = [];
      this.appInList = res.data || [];
      for(var i = 0 ; i < this.appInList.length ; i ++){
        if(this.appInList[i].appssid != ''){
          this.appList.push(this.appInList[i]);
        }
      }
    });
  },
  methods: {
    getTime() {
      this.queryParam.lendingTime = [];
      var nowDate = new Date();
      this.queryParam.lendingTime[0]=moment(nowDate.setDate(nowDate.getDate() - 6));
      this.queryParam.lendingTime[1]=moment(new Date());

    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData()
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      reborrowCount(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          // this.total = res.data.total
          this.dataSource = res.data || [];

        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { lendingTime } = this.queryParam;
      const data = {
          ...this.queryParam,
          settleTimeStart: (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[0]) : undefined,
          settleTimeEnd : (lendingTime && lendingTime.length) ? this.transformTime(lendingTime[1]) : undefined
      }
      delete data.applyDate;
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      this.getTime();
      if (this.queryParam.appSsid) {
        this.queryParam.appSsid = undefined;
      }
      this.queryParam.serviceFee = null;
      this.queryParam.duration = null;
      this.queryParam.orderType = null;
      this.queryParam.settleStatus = null;
      this.queryParam.settleType = null;

      that.loadData(this.form.pageNum)
    },
    changeModal (visible) {
        this.visible = visible;
    },
    downLoadData (arg2) {
      var params = this.getQueryParams(arg2)// Query conditions
      const file = {
        fileUrl: '/api/web/order/countLoanDataWithDateExcel?lendingTimeStart=' + params.lendingTimeStart + '&lendingTimeEnd=' + params.lendingTimeEnd + '&custType=' + params.custType,
        fileName: 'countLoanDataWithDateExcel.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    }

  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
